import LottieSticker from ".";

const FireSticker: React.FC = ({}) => {
    return <LottieSticker lottieName="fire" className={"w-[18px] h-[18px]"} />;
};

export default FireSticker;
